import React from "react";

const InclusionExclusion = ({inclusions, exclusions}) => {
  const inclusionsList = JSON.parse(inclusions);
  const exclusionsList = JSON.parse(exclusions);
  return (
    <div className="inclusion-exclusion">
      <div className="table-container">

        {/* Inclusions Section */}
        <div className="table">
          <h2 className="table-header">Inclusions</h2>
          <ul className="table-content">
            {inclusionsList.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>

        {/* Exclusions Section */}
        <div className="table">
          <h2 className="table-header">Exclusions</h2>
          <ul className="table-content">
            {exclusionsList.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>

      </div>
    </div>
  );
};

export default InclusionExclusion;
